<div class="custom-dialog">
  <!-- Header with Close Button -->
  <div class="dialog-header">
    <div class="close-button">
      <img (click)="noAction()"
           class="cursor-pointer"
           src="/icons/Close.svg">
    </div>
  </div>
  <!-- Main Content -->
  <div class="main-content">
    <!-- Product Image Section -->
    <div class="product-image-section">
      <div class="image-container">
        <img [src]="formatImage('x', data.Service?.Images[0])"
             class="product-image">
      </div>
    </div>
    <!-- Product Details Section -->
    <div class="product-details-section">
      <!-- Product Title and Rating -->
      <div class="product-title-rating">
        <h1 class="product-title">{{ data.Service.Title }}</h1>
        <div class="rating">
          <span class="rating-value">{{ data.Service.Rate || 0 | number:'1.1-1' }}</span>
          <img alt="rating"
               class="star-icon"
               src="/icons/star.svg">
        </div>
      </div>
      <!-- Product Description -->
      <div class="product-description">
        <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(data.Service.Description ?? '')"></p>
      </div>
      <!-- Price Section -->
      <div class="price-section">
        <div class="price-container">
          @if (data.Service?.ServicePrices[0]?.DiscountPercentage) {
            <div class="discount-badge">
              %{{ data.Service?.ServicePrices[0].DiscountPercentage }}
            </div>
          }
          <div class="price-info">
            @if (hasMandatoryServicePriceAdditives(data.Service)) {
              <div class="d-flex align-items-center">
                <span class="currency">از</span>
                <p class="mx-2 current-price">
                  {{ StringUtil.numberAsCurrency(getCheapestServicePriceAdditives(data.Service)) }}
                </p>
                <span class="currency">ریال</span>
              </div>
            } @else {
              @if (data.Service?.ServicePrices[0]?.NewPrice) {
                <div class="current-price">
                  {{ StringUtil.numberAsCurrency(data.Service?.ServicePrices[0]?.NewPrice) }} ریال
                </div>
              } @else {
                <div class="current-price">
                  {{ StringUtil.numberAsCurrency(data.Service?.ServicePrices[0]?.Price) }} ریال
                </div>
              }
              @if (data.Service?.ServicePrices[0]?.NewPrice && data.Service?.ServicePrices[0]?.Price !== data.Service?.ServicePrices[0]?.NewPrice) {
                <div class="original-price">
                  {{ StringUtil.numberAsCurrency(data.Service?.ServicePrices[0]?.Price) }} ریال
                </div>
              }
            }
          </div>
        </div>
        @if (data.Service?.ServicePrices?.[0]?.ServicePriceId) {
          @if (getRemainedCountLabel(data.Service, data.Service?.ServicePrices?.[0].ServicePriceId) !== '0') {
            @if (data.Service.IsOutOfServiceTime) {
              <span class="out-of-stock">خارج از زمان سرویس دهی</span>
            } @else {
              @if (getProductAttributePriceCount(data.Service?.ServicePrices?.[0].ServicePriceId) === 0) {
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <img (click)="onProductOrderClicked(1, $event)"
                       class="cursor-pointer"
                       src="/icons/add-square.svg">
                </div>
              } @else {
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <img (click)="onProductOrderClicked(-1, $event)"
                       class="cursor-pointer"
                       src="/icons/bag.svg">
                  <span class="fz-14">{{ getProductAttributePriceCount(data.Service?.ServicePrices?.[0].ServicePriceId) }}</span>
                  <img (click)="onProductOrderClicked(1, $event)"
                       class="cursor-pointer"
                       src="/icons/add-square.svg">
                </div>
              }
            }
          } @else {
            <span>اتمام موجودی</span>
          }
        }
      </div>
    </div>
  </div>
  <!-- Customer Reviews Section -->
  <div class="reviews-section">
    <h2 class="section-title">
      نظرات کاربران
      ({{ data.Service?.CommentCount }})
    </h2>

    @if (comments.length > 0) {
      @for (comment of comments ?? []; track $index) {
        @if (comment?.Comment) {
          <div class="review-card d-flex">
            <div class="review-header">
              <div class="user-info">
                <p class="user-name">{{ comment?.User?.FirstName + ' ' + comment?.User?.LastName }}</p>
                <p class="review-date">{{ comment?.ModifyDate | time: 'dddd DD MMMM YYYY' }}</p>
                <p class="review-rating">
                  <span class="rating-value">{{ comment?.Rate }}</span>
                  <img alt="rating"
                       src="/icons/star.svg">
                </p>
              </div>
            </div>
            <div class="review-content">
              <p class="review-text">{{ comment?.Comment }}</p>
              <div class="review-tags">
                @for (factorOrder of comment?.Factor.FactorOrders ?? []; track $index) {
                  <span class="tag">{{ factorOrder?.Order?.ServicePrice?.Service?.Title }}</span>
                }
              </div>
              <!-- Replies Section -->
              @if (comment?.Replies && comment.Replies.length > 0) {
                <div class="replies-section">
                  @for (reply of comment.Replies; track $index) {
                    <div class="reply-card">
                      <div class="reply-header">
                        <div class="reply-user-info">
                          <img (error)="onImageError($event)"
                               [src]="formatImage('x', Config.branch.Icon)"
                               alt="رستوران"
                               class="restaurant-icon">
                          <span class="reply-user">{{ reply.User }}</span>
                        </div>
                      </div>
                      <div class="reply-content">
                        <p class="reply-text">{{ reply.Message }}</p>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    } @else {
      <div class="review-card d-flex">
        <span class="rating-value">هنوز نظری ثبت نشده</span>
      </div>
    }
  </div>
</div>
